/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guarantee_Heading_1Inputs */

const et_guarantee_heading_1 = /** @type {(inputs: Guarantee_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matemaatika on`)
};

const en_guarantee_heading_1 = /** @type {(inputs: Guarantee_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The math is`)
};

/**
* | output |
* | --- |
* | "The math is" |
*
* @param {Guarantee_Heading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const guarantee_heading_1 = /** @type {((inputs?: Guarantee_Heading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guarantee_Heading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_guarantee_heading_1(inputs)
	return en_guarantee_heading_1(inputs)
});